/**
 * Mobile navigation drawer.
 */

import { query } from "../core/dom";

const OPEN_CLASS = "is-open";
const BODY_CLASS = "has-open-nav";

/** Wire the hamburger button toggling the navigation on small screens. */
export function initNavigation(): void {
    const toggle = query<HTMLButtonElement>("#nav-toggle");
    const nav = query<HTMLElement>("#site-nav");

    if (!toggle || !nav) {
        return;
    }

    const setOpen = (open: boolean): void => {
        nav.classList.toggle(OPEN_CLASS, open);
        document.body.classList.toggle(BODY_CLASS, open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    toggle.addEventListener("click", () => {
        setOpen(!nav.classList.contains(OPEN_CLASS));
    });

    nav.addEventListener("click", (event: Event) => {
        const target = event.target;
        if (target instanceof HTMLAnchorElement) {
            setOpen(false);
        }
    });

    document.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            setOpen(false);
        }
    });
}
